// using inloopx/cra-docker, it is now possible
// to inject env variables dynamically. These
// variables will be accessed via window.ENV .
// Here we consolidate the 2 environments, one
// coming from process.env (static) and the other
// one from window.ENV (dynamic). The dynamic one
// is used as an override of the static one.
export default { ...process.env, ...window.ENV };
